import graphql__f545653ee837bff1cd63 from "./__generated__/ContributionsDatavizListThemeContribution_contribution.graphql.js";
import graphql__8426eaaf712089467fa4 from "./__generated__/ContributionsDatavizListThemeContribution_theme.graphql.js";import { forwardRef, useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import ReactableMeasures from "../ReactableMeasures";
import UserAvatar from "../../../Users/UserAvatar";
import UserAuthorName from "../../../Users/UserAuthorName";
import { useNavigateTo } from "../../../Routes/RoutesContext";
import { useResponsiveFlag } from "../../../Utils/ResponsiveQueries";
import ContributionCardThemes from "../ContributionCardThemes";
import Button from "../../../Buttons/Button";

const ContributionsDatavizListThemeContribution = (props, ref) => {
  const contribution = useFragment(
    ContributionsDatavizListThemeContribution_contribution,
    props.contribution
  );

  const theme = useFragment(ContributionsDatavizListThemeContribution_theme, props.theme);

  const { slug: participativeModuleSlug } = contribution.participativeModule;
  const { slug: themeSlug } = theme || {};

  const { isDesktop, isNonDesktop } = useResponsiveFlag();

  const { author, title, themes, isFromAdminUser } = contribution;
  const contributionSlug = contribution.slug;

  const navigateTo = useNavigateTo();
  const navigateToContribution = useCallback(() => {
    if (themeSlug) {
      navigateTo("datavizListThemeContribution", {
        participativeModuleSlug,
        themeSlug,
        contributionSlug
      });
    } else {
      navigateTo("datavizSearchContribution", {
        participativeModuleSlug,
        contributionSlug
      });
    }
  }, [contributionSlug, navigateTo, participativeModuleSlug, themeSlug]);

  const handleClick = props.onClick || navigateToContribution;

  // Do not render the box if there's a missing contribution element
  if (!contribution) return null;

  const className = classNames(
    "box",
    "contribution",
    "padding-x-sm",
    "padding-y-xs",
    "btn",
    "btn-block",
    "btn-unstyled",
    props.className,
    { "margin-top-xs": isDesktop },
    { "margin-top-md": isNonDesktop },
    { "admin-highlight": isFromAdminUser }
  );

  return (
    <Button
      onClick={handleClick}
      className={className}
      ref={ref}
      data-show-contribution-button
    >
      <ContributionCardThemes contribution={contribution} theme={theme} />

      <div className="row author margin-bottom-xxs">
        <UserAvatar className="contribution-author-avatar" user={author} />

        <div className="d-flex align-items-center">
          <UserAuthorName user={author} withStatusName={true} />
        </div>
      </div>

      <span className="dataviz-contribution-title d-block margin-bottom-xxs">
        {title}
      </span>

      {themes.map(finalTheme => (
        <span key={finalTheme.id} className="text-muted text-small padding-right-xs">
          {finalTheme.name}
        </span>
      ))}

      <div className="reactions">
        <ReactableMeasures reactable={contribution} />
      </div>
    </Button>
  );
};

const ContributionsDatavizListThemeContributionWithRef = forwardRef(
  ContributionsDatavizListThemeContribution
);

const ContributionsDatavizListThemeContribution_contribution = graphql__f545653ee837bff1cd63;

const ContributionsDatavizListThemeContribution_theme = graphql__8426eaaf712089467fa4;

export default ContributionsDatavizListThemeContributionWithRef;
